import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Breakpoints } from '@client/style/Variables';
import Functions from '@client/style/Functions';
import Arrow from '@client/assets/svgs/arrow.svg';
import { RoundButton } from '@client/modules/shared/Buttons';
import PageHandler from '@client/core/PageSwitch/PageHandler';

const StyledRoundButton = styled(RoundButton)`
	position: absolute;
	z-index: 1;
	top: 120px;
	left: var(--gridMargin);

	svg path {
		stroke: currentColor;
	}

	${Functions.breakpoint(Breakpoints.mobile)} {
		top: 170px;
		left: 75px;
	}
`;

export default function ContentPage({
	theme,
}: {
	theme?: {
		backgroundColor: string;
		contrastColor: string;
	};
}) {
	const link = useMemo(() => {
		const prev = PageHandler.getInstance().previousLink;
		if (prev?.startsWith('/spilleplanen') || prev?.startsWith('/program')) {
			return;
			// return prev;
		}
		return { link: '/program#musik' };
	}, []);

	const onclick = useMemo(() => {
		if (link) return;
		return () => history.back();
	}, [link]);

	return (
		<StyledRoundButton
			colors={{
				bg: theme?.backgroundColor,
				fg: theme?.contrastColor,
			}}
			link={link}
			onClick={onclick}
		>
			<Arrow />
		</StyledRoundButton>
	);
}
